import style from "../inputText/Input.module.css";

function TextArea(props){


    return (
        <div>
            {/* aria-label fornisce il nome accessibile del campo (WCAG 1.3.1 / 3.3.2):
                l'etichetta visibile e' uno <span> adiacente non associato
                programmaticamente. Attributi ARIA: nessun impatto sulla resa grafica. */}
            <textarea
                className={props.errorClause? style.errorBorder:style.txtInput}
                placeholder={props.placeholder}
                id={props.id}
                aria-label={props.ariaLabel}
                aria-invalid={props.errorClause ? "true" : undefined}
                aria-describedby={props.errorClause ? `${props.id}-errore` : undefined}
                value={props.value}
                onChange={props.onChange}
                disabled={props.disabled}
                style={props.style}
                rows={props.rows}
                cols={props.cols}
            />
            <div>
                {/* Messaggio d'errore: <span> collegato con aria-describedby anziche'
                    <label htmlFor>, che ne faceva il nome accessibile (WCAG 3.3.1). */}
                {props.errorClause?<span id={`${props.id}-errore`} role="alert" className={style.errorMessage}>{props.errorMessage}</span>:null}
            </div>
        </div>

    )


}
export default TextArea